import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const getStaff = () => localStorage.getItem("staff_name") || "";
export const setStaff = (n) => localStorage.setItem("staff_name", n);

api.interceptors.request.use((cfg) => {
  cfg.headers["X-Staff-Name"] = getStaff() || "Unknown staff";
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (d.missing) return `${d.message}: ${d.missing.join("; ")}`;
  return d.message || JSON.stringify(d);
}

export const exportUrl = (jobId, kind) =>
  `${API}/jobs/${jobId}/export/${kind}?who=${encodeURIComponent(getStaff() || "Unknown staff")}`;

export const STAGES = [
  { id: 0, name: "Intake" },
  { id: 1, name: "JD collection" },
  { id: 2, name: "Market analysis" },
  { id: 3, name: "Gap check" },
  { id: 4, name: "Positioning" },
  { id: 5, name: "Draft" },
  { id: 6, name: "Recruiter panel" },
  { id: 7, name: "Boolean & ATS" },
  { id: 8, name: "Humanize" },
  { id: 9, name: "Fact check" },
  { id: 10, name: "Review & export" },
];
export const LEVELS = ["Intern", "Entry", "Mid", "Senior", "Lead", "Manager", "Director"];
export const VISAS = ["F-1 OPT", "STEM OPT", "H-1B", "H-4 EAD", "L-2 EAD", "Green Card", "US Citizen", "Other"];
export const FACT_TYPES = ["number", "tool", "scope", "win", "title", "date"];
export const FACT_SOURCES = ["resume", "call", "document", "LinkedIn"];

export const STATUS_STYLE = {
  approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  ready: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  running: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  failed: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  pending: "bg-slate-500/10 text-slate-400 border-slate-500/30",
};
export const STATUS_LABEL = {
  approved: "Approved", ready: "Awaiting approval", running: "Running", failed: "Failed", pending: "Not started",
};
